import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

interface SenderFooterProps {
	children: ReactNode;
	className?: string;
}

export default function SenderFooter({ children, className }: SenderFooterProps) {
	return (
		<div
			className={cn(
				'shrink-0 border-t border-border/60 bg-background/95 px-3 pt-3 pb-[max(0.5rem,env(safe-area-inset-bottom))] backdrop-blur-sm',
				className,
			)}
		>
			{children}
		</div>
	);
}
